import styled from "styled-components";

import {
  DATA_E2E_KEY,
  DRAWER_START_INLINE_GAP,
  IStyledAttributes,
} from "@ryde/shared";
import { MOBILE_BREAKPOINT } from "@ryde/theme";

export const RichViewLogsHeaderStyled = styled.header.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "rich-view-logs-drawer-header",
})`
  width: 100%;
  background-color: rgb(255, 255, 255);
  border-bottom: 1px solid rgb(224, 224, 224);
  display: flex;
  align-items: center;
  padding-inline-start: ${DRAWER_START_INLINE_GAP}px;
  min-height: 56px;
  padding-block: 8px;

  .DrawerCloseIconButton {
    margin-inline-start: -8px;
    margin-inline-end: 8px;
  }

  .view-logs-save-csv-logs-link {
    margin-inline-start: auto;
    margin-inline-end: 12px;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    .DrawerHeaderTitle {
      order: 1;
    }
    .view-logs-save-csv-logs-link {
      order: 2;
    }
    .DrawerCloseIconButton {
      order: 3;
      margin-inline-start: auto;
      margin-inline-end: 6px;

      > svg {
        height: 20px;
        width: 20px;
      }
    }
  }
`;
